export function Loader() {
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <svg
        width="50px"
        height="50px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        className="lds-ring">
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke="var(--primary-color)"
          strokeWidth="7"
          r="40"
          strokeDasharray="188.49555921538757 64.83185307179586"
          transform="rotate(214.662 50 50)">
          <animateTransform
            attributeName="transform"
            type="rotate"
            calcMode="linear"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
            dur="1s"
            begin="0s"
            repeatCount="indefinite"></animateTransform>
        </circle>
      </svg>
    </div>
  );
}
